jQuery(function ($) {
  const Scripts = {
    varInit() {
      this.header = $("header");
      this.document = $(document);
    },

    toggleMenu() {
      $(document).on("click", ".burger-menu-js", function () {
        $("body").toggleClass("menu-open");
      });
    },
    initSlider() {      
      if (document.querySelector('.article-slider') &&
          document.querySelector('.thumbnail-slider')) {
            
          const thumbnailSwiper = new Swiper(".thumbnail-slider", {
          spaceBetween: 10,
          slidesPerView: "auto",
          freeMode: true,
          watchSlidesProgress: true,
        });
        new Swiper(".article-slider", {
          slidesPerView: 1,
          navigation: {
            nextEl: ".thumbnail-swiper__next",
            prevEl: ".thumbnail-swiper__prev",
          },
          thumbs: {
            swiper: thumbnailSwiper,
          },
        });
      }
    },
    customCopyValue() {
      const copyItems = document.querySelectorAll("[data-copy]"); // svgs

      if (copyItems.length > 0) {
        copyItems.forEach((item) => {
          item.addEventListener("click", copyValue);
        });
      }
    
      function copyValue(e) {
        const current = e.currentTarget;

        let trimedText;
      
        // <a> links
        if (current.nodeName !== "BUTTON") {
          const copyText = current.nextElementSibling;
          const tipElem = copyText.nextElementSibling;

          trimedText = copyText.textContent.trim();

          tipElem.classList.add("show-tip");

          setTimeout(() => {
            tipElem.classList.remove("show-tip");
          }, 4000)

        // <button> - copy icon
        } else {
          trimedText = current.getAttribute('data-value');
          current.classList.add("show-tip");
          
          setTimeout(() => {
            current.classList.remove("show-tip");
          }, 4000)
        }
    
        navigator.clipboard
        .writeText(trimedText)
        .then(() => {
          console.log("Text copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
      }
    },
    acordeon() {
      const activityItems = document.querySelectorAll('.activity-areas__item');

      activityItems.forEach(activityItem => {
        activityItem.addEventListener('click', showContent);
      });

      function showContent(e) {
        const target = e.currentTarget;
        const p = target.querySelector('p');
        
        activityItems.forEach(activityItem => {
          activityItem.classList.remove('active');
        });

        target.classList.add('active');
        target.classList.add('active');

      }
    },
    dateValidation() {
      // Date vlidation
      const dateInput = document.querySelector('[name="Geburtsdatum"]');
      
      dateInput.addEventListener('input', (e) => {
        let value = e.target.value.replace(/\D/g, '');
        const currentYear = new Date().getFullYear();
      
        if (value.length > 8) value = value.slice(0, 8);
      
        if (value.length >= 2) {
          let day = value.slice(0, 2);
          let month = value.slice(2, 4);
          let year = value.slice(4, 8);
      
          // Ensure day is between 1 and 31
          if (parseInt(day, 10) > 31) day = '31';
      
          // Ensure month is between 1 and 12
          if (month && parseInt(month, 10) > 12) month = '12';
      
          // Ensure year is not greater than the current year
          if (year && parseInt(year, 10) > currentYear) year = currentYear.toString();
      
          // Format the value
          value = day;
          if (month) value += `.${month}`;
          if (year) value += `.${year}`;
        }
      
        e.target.value = value;
      });

      // Number Validation
      const telInput = document.querySelector('[name="Telefonnummer"]');
      if (telInput) {
        telInput.addEventListener('input', () => {
          telInput.value = telInput.value.replace(/\D/g, '').trim();
        });
      }

      // Set specified donate value
      const selectField = document.querySelector('[name="contribution-amount"]');
      if (selectField) {
          const defaultValue = "€100";
  
          selectField.value = defaultValue;
          
          selectField.addEventListener('change', function() {
              if (this.value === "") {
                  this.value = defaultValue;
              }
          });
      }
      
    },
    showField() {
      const selectElement = document.querySelector("select[name='contribution-amount']");
      const targetElement = document.querySelector("input[name='Beitrages']");

      if (targetElement.classList.contains('hidden-field')) {
        targetElement.required = false;
        targetElement.setAttribute('aria-required', 'false');
      }

      selectElement.addEventListener("change", function () {
        if (selectElement.value === "Eigener Betrag") {
            targetElement.classList.remove("hidden-field");
            targetElement.required = true;
            targetElement.setAttribute('aria-required', 'true');
        } else {
            targetElement.classList.add("hidden-field");
            targetElement.required = false;
            targetElement.removeAttribute('aria-required');
        }
      });
    },
    scrollAfterSubmit() {
      document.addEventListener('wpcf7submit', function(event) {
        if ('76' == event.detail.contactFormId) {

          const memberHero = document.querySelector('.member-hero__inner');
          const position = memberHero.getBoundingClientRect().top + window.pageYOffset;
  
          window.scrollTo({
            top: position + 100,
            behavior: 'smooth'
          });
        }
      }, false);
    },
    
    init() {
      Scripts.varInit();
      Scripts.toggleMenu();
      Scripts.initSlider();
      Scripts.customCopyValue();
      Scripts.acordeon();

      if ($(".member-form ").length) {
        Scripts.dateValidation();
        Scripts.showField();
        Scripts.scrollAfterSubmit();
      }
    },
  };

  $(document).ready(function () {
    Scripts.init();
  });
});
